import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "contents-title-text ma-4 text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_card = _resolveComponent("v-card");
    const _component_BarogoTooltip = _resolveComponent("BarogoTooltip");
    return (_openBlock(), _createBlock(_component_BarogoTooltip, {
        "without-icon": "",
        "content-class": "tooltip elevation-3 pa-0"
    }, {
        activatorSlot: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.workerName), 1 /* TEXT */)
        ]),
        tooltipMessage: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t(`${_ctx.lc}worker_agency`)), 1 /* TEXT */),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card, {
                width: "340",
                elevation: "0"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pa-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'hub_agency')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.allocatedHubName), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }));
}
